{
  "version": 1,
  "asset_id": "88b0bd1c-d289-4f74-8cf3-46cae58187ed",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/88b0bd1c-d289-4f74-8cf3-46cae58187ed/form-433a.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/88b0bd1c-d289-4f74-8cf3-46cae58187ed/form-433a.jpg",
  "original_filename": "form-433a.jpg",
  "size": 175954,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:56Z"
}
